export const LabelTextId = 'frequency-label-text';
